// extracted by mini-css-extract-plugin
module.exports = {"container":"SortingAlgo_container__2DCZe","algoContainer":"SortingAlgo_algoContainer__1rmbD","algoName":"SortingAlgo_algoName__2Bkmf"};